export default __webpack_public_path__ + "static/media/decorative.4e6ebf59.jpg";